<template>
  <div class="box1">
    <!-- 顶部公司介绍 -->
    <div class="screen">
      <div class="corporation-details">
        <div class="details-left">
          <!-- 公司信息 -->
          <div class="corporation-Message">
            <div class="logo">
              <img :src="argument.logoImg" alt="" />
            </div>
            <div class="Message">
              <div class="Message-box">
                <p class="Company-name">{{ argument.companyName }}</p>
                <!-- 点击切换样式 div-select -->
                <div
                  :class="
                    argument.hasCollect == true ? 'Collect' : 'NotCollect'
                  "
                  @click.stop="handelCollect(argument)"
                ></div>
              </div>

              <!-- 上班时间 -->
              <div class="Message-box">
                <p
                  v-if="
                    argument.workingHours != null && argument.workingHours != ''
                  "
                >
                  工作时间：{{ argument.workingHours }}
                </p>
                
                <p v-if="argument.financing!=null&&argument.financing!=''">{{ argument.financingName }}</p>
                <p>{{ argument.industryTypeName }}</p>
                <p v-if="argument.enterpriseSize!=null&&argument.enterpriseSize!=''">{{ argument.enterpriseSizeName }}</p>
                <p>{{ argument.establishmentDate }}</p>
              </div>
            </div>
          </div>
          <!-- 公司福利 -->
          <div class="corporation-Bonus" v-if="argument.baseWelfareList.length>0">
            福利待遇：
            <p v-for="(item, index) in argument.baseWelfareList" :key="index">
              {{ item.welfareName }}
            </p>
          </div>
        </div>
        <div class="details-right">
          <!-- 在招 -->
          <div class="OnRecruit">
            共有<span> {{ argument.jobTotalCount }} </span>个职位在招
          </div>
          <!-- 举报 -->
          <div class="report">
            <div class="firm-clickable" @click="handelReport"></div>
            <p class="firm-clickable" @click="handelReport">举报</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 主体 -->
    <div class="details-Navigation">
      <p
        v-for="(item, index) in ToggleList"
        :key="index"
        :class="item.id == select ? 'select-p' : ''"
        @click="handelClick(item.id)"
      >
        {{ item.name }}
        <span v-if="item.id == 2">({{ pagingObj.totalDevice }})</span>
      </p>
    </div>
    <div class="Core">
      <firmDetails
        v-if="select == '1'"
        :argument="argument"
        :tabulationArr="tabulationArr"
        :tabulationArr1="tabulationArr1"
        :tabulationArr2="tabulationArr2"
      ></firmDetails>
      <comCore
        v-if="select == '2'"
        :listArr="listArr"
        @Refresh="getCompanyPositions()"
      ></comCore>
    </div>
    <!-- 分页 -->
    <div class="paging" v-if="select == '2'">
      <div class="paging-cen">
        <paging
          :pagingObj="pagingObj"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </div>
    </div>
    <ReportWin
      :dialogReport="dialogReport"
      :reportData="argument"
      :type="1"
      :id="argument.companyId"
      :name="argument.companyName"
      :code="argument.code"
      :firmId="argument.companyId"
      @handleCloseReport="handleCloseReport"
      @handleUnderstand="handleUnderstand"
    ></ReportWin>
  </div>
</template>

<script>
// 引入职位收藏页的接口
import {
  addCompanyCollect, // 收藏公司
  cancelCompanyCollect, // 取消公司收藏
} from "../../../assets/api/CentreCollect";
// 引入接口
import {
  getCompanyBusinessInformation, //查询公司工商信息
} from "../../../assets/api/firm/firmCenter";
// 引入推荐企业页的接口
import {
  getCompanyDetail, // 公司详情
  getCompanyPositions, // 公司发布的职位
} from "../../../assets/api/Recommended";
// 引入 在招职位 组件
import comCore from "./components/comCore.vue";
// 引入 公司介绍 组件
import firmDetails from "./components/firmDetails.vue";
// 引入分页 组件
import paging from "../../../components/paging.vue";
// 举报弹窗
import ReportWin from "../../../components/report.vue";
export default {
  components: {
    // Tintro,
    comCore,
    firmDetails,
    paging,
    ReportWin,
  },
  data() {
    return {
      select: "1", // 选择公司介绍/招聘职位
      ToggleList: [
        { name: "公司介绍", id: "1" },
        { name: "热聘职位", id: "2" },
      ],
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 15, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页数据
      argument: {}, // 用于举报/展示  使用的企业 信息
      dialogReport: false, // 举报弹窗
      BonusList: ["五险一金", "节日福利", "免费班车", "周末双休"], // 福利待遇列表
      companyId: "", // 点击企业跳转携带的企业id
      listArr: [], // 公司发布的职位列表

      tabulationArr: [
        { title: "法定代表人", content: "", key: "legalPerson" },
        {
          title: "名称",
          content: "",
          key: "companyName",
        },
        { title: "注册号", content: "", key: "rn" },
        {
          title: "统一信用代码",
          content: "",
          key: "usci",
        },
        { title: "经营状态", content: "", key: "businessStatus" },
        {
          title: "企业类型",
          content: "",
          key: "companyType",
        },
        {
          title: "所属地区/邮编",
          content: "",
          key: "locationPostCode",
        },
      ],
      tabulationArr1: [
        {
          title: "纳税人识别号",
          content: "",
          key: "tin",
        },
        { title: "机构代码", content: "", key: "ic" },
        { title: "注册资本", content: "", key: "registeredCapital" },
        {
          title: "登记机关",
          content: "",
          key: "registrationAuthority",
        },
        { title: "成立日期", content: "", key: "establishmentDate" },
        {
          title: "经营期限",
          content: "",
          key: "operatingPeriod",
        },
        { title: "核准日期", content: "", key: "approvedDate" },
      ],
      tabulationArr2: [
        {
          title: "企业地址",
          content: "",
          key: "companyAddress",
        },
        {
          title: "经营范围",
          content: "",
          key: "businessScope",
        },
        { title: "注册资本", content: "", key: "registeredCapital" },
      ],
    };
  },
  created() {
    if (this.$route.query.key != "" && this.$route.query.key != undefined) {
      this.companyId = this.$route.query.key;
      this.select = this.$route.query.select;
      console.log(this.$route.query.key, 11111, this.$route.params.key);
      // 公司发布的职位
      this.getCompanyPositions();
      // 公司详情
      this.getCompanyDetail();
      // 工商信息
      this.getCompanyBusinessInformation();
    }
  },
  mounted() {},
  destroyed() {},
  methods: {
    // 工商信息
    getCompanyBusinessInformation() {
      var data = {
        data: {
          companyId: this.companyId,
        },
      };
      getCompanyBusinessInformation(data).then((res) => {
        // 对象 变数组
        var obj = Object.entries(res.data).map(([key, val]) => ({
          key,
          val,
        }));
        for (var i in obj) {
          for (var k in this.tabulationArr) {
            if (this.tabulationArr[k].key == obj[i].key) {
              this.tabulationArr[k].content = obj[i].val;
            }
          }
          for (var k in this.tabulationArr1) {
            if (this.tabulationArr1[k].key == obj[i].key) {
              this.tabulationArr1[k].content = obj[i].val;
            }
          }
          for (var k in this.tabulationArr2) {
            if (this.tabulationArr2[k].key == obj[i].key) {
              this.tabulationArr2[k].content = obj[i].val;
            }
          }
        }
      });
    },
    // 点击收藏 /取消收藏
    handelCollect(item) {
      // 参数
      var data = {
        data: {
          userId: this.$store.getters.getUser.id,
          companyId: item.companyId,
        },
      };
      if (item.hasCollect == true) {
        // 调用接口
        cancelCompanyCollect(data).then((res) => {
          if (res.code == 0) {
            // 成功 改变图标样式
            this.$tool.PromptBox("success", "操作成功");
            item.hasCollect = false;
          } else {
            // 失败
            // this.$tool.PromptBox("error", res.msg);
          }
        });
      } else {
        if (
          this.$store.getters.getUser.id != "" &&
          this.$store.getters.getUser.id != undefined
        ) {
          // 调用接口
          addCompanyCollect(data).then((res) => {
            if (res.code == 0) {
              // 成功 改变图标样式
              this.$tool.PromptBox("success", "收藏成功");
              item.hasCollect = true;
            }
          });
        } else {
          this.$tool.PromptBox("warning", "请先登录！");
        }
      }
    },
    // 公司详情接口
    async getCompanyDetail() {
      var data = {
        data: {
          companyId: this.companyId,
        },
      };
      // 请求公司详情接口
      const res = await getCompanyDetail(data);
      console.log(res, "res1111");
      // 获取到数据
      this.argument = res.data;
    },
    // 公司发布的职位接口
    async getCompanyPositions() {
      var data = {
        data: {
          userId: this.$store.getters.getUser.id,
          companyId: this.companyId,
        },
      };
      const res = await getCompanyPositions(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      );
      console.log(res, "res");
      this.pagingObj.totalDevice = res.data.total;
      this.listArr = res.data.list;
    },
    // 举报
    handelReport() {
      console.log(this.argument);
      this.dialogReport = true;
    },
    // 关闭弹窗
    handleCloseReport() {
      this.dialogReport = !this.dialogReport;
    },
    // 弹窗确定
    handleUnderstand() {
      this.dialogReport = !this.dialogReport;
    },
    // 切换 公司介绍/热聘职位
    handelClick(num) {
      this.select = num;
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      this.getCompanyPositions();
    },
  },
};
</script>

<style scoped lang="less">
.box1 {
  width: 100%;
}
// 筛选区
.screen {
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
  border-radius: 5px;
  .corporation-details {
    width: 1184px;
    display: flex;
    padding-bottom: 50px;
    padding-top: 30px;
    margin: auto;
    // 头部左侧公司详情
    .details-left {
      flex: 1;
      display: flex;
      flex-direction: column;
      // 公司信息
      .corporation-Message {
        width: 100%;
        height: 70px;
        display: flex;
        .logo {
          width: 70px;
          height: 70px;
          margin-right: 30px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        //公司信息
        .Message {
          flex: 1;
          height: 70px;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          font-family: PingFangSC-Medium;
          font-weight: 400;
          .Message-box {
            width: 100%;
            height: 20px;
            line-height: 20px;
            margin: auto;
            display: flex;
            font-size: 13px;
            color: #333300;
            .Company-name {
              font-size: 20px;
              color: #333300;
              font-weight: 600;
            }

            // 公司是否收藏
            .Collect {
              width: 20px;
              height: 20px;
              background-image: url("../../../assets/imgs/shoucang@3x.svg");
              background-size: 100% 100%;
            }
            .NotCollect {
              width: 20px;
              height: 20px;
              background-image: url("../../../assets/imgs/shoucang-null@3x.svg");
              background-size: 100% 100%;
            }
            .div-select {
              background-image: url("../../../assets/imgs/shoucang@3x.svg");
              background-size: 100% 100%;
            }
            p {
              margin-right: 20px;
            }
          }
        }
      }
      // 公司福利
      .corporation-Bonus {
        // border: 1px solid gold;
        width: 100%;
        height: 25px;
        line-height: 25px;
        margin-top: 20px;
        font-size: 16px;
        color: #333300;
        font-weight: 400;
        display: flex;
        flex-wrap: wrap;
        p {
          padding: 0 5px;
          min-width: 65px;
          max-width: 90px;
          height: 25px;
          line-height: 25px;
          background: #eeeeee;
          border-radius: 5px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-family: PingFangSC-Medium;
          font-size: 12px;
          color: #333333;
          text-align: center;
          font-weight: 400;
          margin-right: 20px;
          margin-bottom: 10px;
        }
      }
    }
    // 头部右侧 举报   在招
    .details-right {
      // border: 1px solid gold;
      width: 200px;
      display: flex;
      flex-direction: column;
      // 在招
      .OnRecruit {
        width: 100%;
        height: 70px;
        line-height: 30px;
        font-size: 15px;
        color: #409eff ;
        text-align: right;
        font-weight: 400;
        span {
          font-size: 30px;
        }
      }
      // 举报
      .report {
        width: 100%;
        height: 25px;
        line-height: 25px;
        display: flex;
        justify-content: flex-end;
        p {
          font-size: 16px;
          color: #333333;
          font-weight: 400;
          cursor: pointer;
        }
        div {
          width: 25px;
          height: 25px;
          background-image: url("../../../assets/imgs/jinggao-L@3x.svg");
          background-size: 100% 100%;
          margin-right: 10px;
          cursor: pointer;
        }
      }
    }
  }
}
//
.details-Navigation {
  width: 1184px;
  height: 49px;
  margin: auto;
  margin-top: 16px;
  margin-bottom: 16px;
  display: flex;
  p {
    min-width: 110px;
    height: 49px;
    line-height: 49px;
    padding: 0px 5px 0px 5px;
    background: #eeeeee;
    border-radius: 5px;
    font-family: PingFangSC-Medium;
    font-size: 18px;
    color: #999999;
    text-align: center;
    font-weight: 400;
    margin-right: 10px;
    cursor: pointer;
  }
  .select-p {
    background: rgba(97, 144, 232, 0.2);
    color: #409eff ;
  }
}
.Core {
  max-width: 1184px;
  min-height: 800px;
  margin: auto;
  // padding-top: 5px;
}
.paging {
  max-width: 1230px;
  margin: auto;
  display: flex;
  margin-top: 40px;
  .paging-cen {
    margin: auto;
  }
}
</style>
